<template>
  <div class="nav-content">
    <span>科技让生活更美好</span>
    <div @click="logout" class="nav-content-div">退出</div>
    <div style="display: inline-block; float: right;" class="nav-content-name">{{ $store.state.accountName }}</div>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  data() {
    return {
      dialogVisible: false,
      accountName: null,
    };
  },
  watch: {
    '$store.state.accountName': function () {
      this.accountName = this.$store.state.accountName;
    },
  },
  methods: {
    logout() {
      api.logout();
      this.$router.push('/');
    },
  },
};
</script>

<style lang="less" scoped>
.nav-content {
  width: 100%;
  height: 70px;
  background-color: #188fff;
  border-bottom: 1px solid #fff;
  span {
    color: #fff;
    line-height: 70px;
  }
  span:first-child {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    padding-left: 40px;
  }
  span:last-child {
    font-size: 12px;
  }
  .nav-content-div {
    height: 70px;
    line-height: 70px;
    width: 150px;
    text-align: center;
    float: right;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    border-left: 1px solid #fff;
    letter-spacing: 4px;
  }
  .nav-content-name {
    height: 70px;
    line-height: 70px;
    width: 120px;
    text-align: center;
    float: right;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    // border-left: 1px solid #fff;
    // letter-spacing: 4px;
  }
  div:hover {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue